module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["wrapper"],
    style: _vm.wrapperStyleComp
  }, [(_vm.hasDot === true && _vm.size !== 'min') ? _c('div', {
    staticClass: ["dot-triangle"],
    style: {
      backgroundColor: _vm.iconColor
    }
  }) : _vm._e(), _c('div', {
    staticClass: ["btn-wrapper"],
    style: _vm.btnWrapperStyle
  }, [_c('div', {
    staticClass: ["btn"],
    style: _vm.btnSizeComp,
    on: {
      "click": _vm.btnClickedHandler
    }
  }, [(_vm.imgUrl) ? _c('div', {
    staticClass: ["btn-img-container"]
  }, [_c('image', {
    staticClass: ["btn-img"],
    style: _vm.btnImgSizeComp,
    attrs: {
      "src": _vm.imgUrl
    }
  })]) : _c('text', {
    staticClass: ["btn-text"],
    style: _vm.textColorComp
  }, [_vm._v(_vm._s(_vm.text))])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-07569f6c!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-circle-button/index.vue
// module id = 572
// module chunks = 0 1